define(
  'app/views/grouped_products_view',['app/setup', 'app/views/grouped_product_view'],
  function(takhfifan, groupedProductView) {

  takhfifan.GroupedProductsView = Backbone.View.extend({

    initialize: function(options) {
      this.childRendered = false;
      this.productId = options.productId;
      this.collection =  options.collection;
      this.$listElements = new Array();
      takhfifan.eventHub.on('timeover:' + this.productId, function() {
        this.disable();
      }, this);

      takhfifan.eventHub.on('overlay:blur', function() {
        this.hideOptions();
      }, this);

    },

    showOptions: function(event) {
      if (!this.childRendered) {
        this.renderOptionViews();
      }
      if(this.$listElements.length > 1){
        $('.modal-overlay').fadeIn('fast');
        this.$el.fadeIn('fast');
      }else if(this.$listElements.length === 1){
        takhfifan.eventHub.trigger('buyButton:loading');
        this.$listElements[0].addToCart()
      }
    },

    renderOptionViews: function(){
      var element = this.$el.find('.items-list ul'),
          productId = this.productId,
          _this = this;

      this.collection.each(function(item){
        if(productId!==item.id){
          var itemView = new takhfifan.GroupedProductView({
            model: item,
            parentProductId: productId,
            parentEl: element
          });

          element.append(itemView.render().el);
          _this.$listElements.push(itemView);
        }
      });
      this.childRendered = true;
    },

    hideOptions: function() {
      this.$el.fadeOut('fast');
    },

    disable: function() {
      this.hideOptions();
      this.undelegateEvents();
    }

  });

});

